import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AllocationViewSlotBriefLoad, AllocationViewSlotBriefInitialState } from './allocation-view-slot-brief.actions';
import { ActionBriefInterface, ActionBriefModel } from '../../allocation-view';
import { AllocationViewSlotBriefState } from './allocation-view-slot-brief.state';
import { AllocationViewSlotBriefModel } from '../models';
import { SetInitialStateFacade } from '../../../../../common';
import { Observable } from 'rxjs';
import { BriefLocationInfoInterface, BriefLocationInfoModel } from '../models/allocation-brief-models';

@Injectable({ providedIn: 'root' })
export class AllocationViewSlotBriefFacade
  implements SetInitialStateFacade, BriefLocationInfoInterface, ActionBriefInterface
{
  slot$: Observable<AllocationViewSlotBriefModel> = this.store.select(AllocationViewSlotBriefState.getSlotBrief);
  locationInfo$: Observable<BriefLocationInfoModel> = this.store.select(AllocationViewSlotBriefState.getLocationInfo);
  actionBriefDetails$: Observable<ActionBriefModel> = this.store.select(
    AllocationViewSlotBriefState.getActionBriefDetails,
  );
  loaded$: Observable<boolean> = this.store.select(AllocationViewSlotBriefState.getLoaded);

  constructor(private store: Store) {}

  getSlotBrief(compartmentId: number, slotId: number): void {
    this.store.dispatch(new AllocationViewSlotBriefLoad({ compartmentId, slotId }));
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewSlotBriefInitialState());
  }
}
